export default {
  // Hero
  zimmerKicker: 'Our rooms',
  zimmerHeroTitle1: 'Arrive. Settle in.',
  zimmerHeroTitle2: 'Never want to leave.',
  zimmerHeroLead: 'Three room categories. One promise: calm, comfort and the feeling of being truly welcome.',

  // Sticky filter
  zimmerFilterAll: 'All rooms',
  zimmerFilterDoppel: 'Double rooms',
  zimmerFilterEinzel: 'Single rooms',
  zimmerFilterKomfort: 'Comfort double rooms',

  // Kachel-Prefix
  zimmerPrefixDZ: 'Double room',
  zimmerPrefixEZ: 'Single room',

  // Doppelzimmer card
  zimmerDZTitle: 'Double room',
  zimmerDZSize: 'approx. 20 m²',
  zimmerDZGuests: '2 guests',
  zimmerDZPrice: 'from €179',
  zimmerDZPriceNote: 'per night, breakfast included',
  zimmerDZTag1: 'Private bathroom',
  zimmerDZTag2: 'Free Wi-Fi',
  zimmerDZTag3: 'Free parking',
  zimmerDZDescription: 'Very comfortable beds. Mattresses available in two firmness levels. On request: hypoallergenic pillows, spelt-husk pillows, extra mattress toppers, summer duvets and more.',

  // Einzelzimmer card
  zimmerEZTitle: 'Single room',
  zimmerEZSize: '7 – 11 m²',
  zimmerEZGuests: '1 guest',
  zimmerEZPrice: 'from €99',
  zimmerEZPriceNote: 'per night, breakfast included',
  zimmerEZTag1: 'Green outlook',
  zimmerEZTag2: 'Private bathroom',
  zimmerEZTag3: 'Free Wi-Fi',
  zimmerEZTag4: 'Free parking',
  zimmerEZDescription: 'Very comfortable bed. On request: hypoallergenic pillows, spelt-husk pillows, extra mattress toppers, summer duvets and more.',

  // Komfort
  zimmerKomfortTitle: 'Comfort double room',
  zimmerKomfortSize: 'approx. 30 m²',
  zimmerKomfortGuests: '2 guests',
  zimmerKomfortPrice: 'from €199',
  zimmerKomfortTag1: 'Separate living & sleeping area',
  zimmerKomfortTag2: 'Garden view',
  zimmerKomfortTag3: 'Private bathroom',
  zimmerKomfortTag4: 'Free Wi-Fi',
  zimmerKomfortTag5: 'Free parking',
  zimmerKomfortDescription: 'Very comfortable beds. Mattresses available in two firmness levels. On request: hypoallergenic pillows, spelt-husk pillows, extra mattress toppers, summer duvets and more.',

  // Buttons
  zimmerToggleAmenitiesShow: 'Show amenities',
  zimmerToggleAmenitiesHide: 'Show less',
  zimmerAmenitiesTitle: 'Amenities in detail',
  zimmerToggleAllDZShow: 'View all double rooms',
  zimmerToggleAllDZHide: 'Show less',
  zimmerToggleAllEZShow: 'View all single rooms',
  zimmerToggleAllEZHide: 'Show less',
  zimmerBookCta: 'Book now',

  // Amenities
  amenitySitzbereich: 'Seating area',
  amenitySafe: 'Safe',
  amenityBad: 'Bathroom with shower',
  amenitySchreibtisch: 'Desk',
  amenityTv: 'Flat-screen TV / radio',
  amenityPflege: 'Premium toiletries',
  amenityTeppich: 'Carpeted floor',
  amenitySat: 'Satellite TV',
  amenityHaartrockner: 'Hair dryer',
  amenitySchrank: 'Wardrobe',
  amenityTel: 'Phone / wake-up service',
  amenityHausschuhe: 'Slippers',
  amenityWohnSchlaf: 'Living and sleeping area',

  // Wichtige Infos
  zimmerInfoTitle: 'Good to know',
  zimmerInfoCheckin: 'Check-in:',
  zimmerInfoCheckinValue: 'from 3 pm',
  zimmerInfoCheckout: 'Check-out:',
  zimmerInfoCheckoutValue: 'until 12 noon',
  zimmerInfoBreakfast: 'Breakfast:',
  zimmerInfoBreakfastValue: '7 – 10 am, weekends/holidays 8 – 11 am',
  zimmerInfoParking: 'Parking:',
  zimmerInfoParkingValue: 'free of charge',
  zimmerInfoWifi: 'Wi-Fi:',
  zimmerInfoWifiValue: 'free of charge',
  zimmerInfoPets: 'Pets:',
  zimmerInfoPetsValue: 'not allowed (in consideration of guests with allergies)',

  // CTA
  zimmerCtaTitle: 'Ready for your stay?',
  zimmerCtaText: 'Choose your room, check availability and look forward to restful days at the Alpenhof.',
  zimmerCtaButton: 'Check availability now',
};
